import { Injectable } from '@angular/core';
import {ApiService} from './api.service';
import {map} from 'rxjs/operators';
import {
  DeliverySlots,
  NextDeliverySlots,
  Restaurant
} from '../restaurant-manager.models';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DeliverySlotService {

  constructor(private apiService: ApiService) { }

  next(restaurant: Restaurant): Observable<NextDeliverySlots> {
    return this.apiService.get<NextDeliverySlots>('/delivery/restaurant/' + restaurant.id + '/next').pipe(map( nextSlots => {
      return new NextDeliverySlots(nextSlots);
    }));
  }

  list(restaurant: Restaurant): Observable<DeliverySlots> {
    return this.apiService
      .get<DeliverySlots>('/delivery/restaurant/' + restaurant.id)
      .pipe(map(result => new DeliverySlots(result)));
  }

  listStatuses(restaurant: Restaurant): Observable<DeliverySlots> {
    return this.apiService
      .get<DeliverySlots>('/delivery/restaurant/' + restaurant.id + '/statuses', true)
      .pipe(map(result => new DeliverySlots(result)));
  }

  update(deliverySlotId: string, isOpen: boolean): Observable<boolean> {
    return this.apiService
      .put<boolean>('/delivery/' + deliverySlotId, { isOpen }, true);
  }

}
